"use client";

import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { useEffect, useState } from "react";
import DialogSuccess from "./DialogSuccess";
import { useAtom } from "jotai";
import { showManageUserModalAtom } from "../../store";
import DialogDelete from "./DialogDelete";
import DialogSales from "./DialogSales";
import { updateUserProfile } from "../../firebase/users";
import { getWithdrawsByUserId } from "../../firebase/payments";
import { formatDate } from "../../utils";

export default function DialogManageUser({
    open,
    onClose,
    user
}) {
    const [showSuccessDialog, setShowSuccessDialog] = useState(false)
    const [showDeactivateModal, setShowDeactivateModal] = useState(false)
    const [showSalesModal, setShowSalesModal] = useState(false)
    const [, setShowManageUserModal] = useAtom(showManageUserModalAtom)
    const [withdrawals, setWithdrawals] = useState([])

    useEffect(() => {
        getWithdrawsByUserId(user.id).then(data => {
            setWithdrawals(data)
        })
    }, [user])

    const onClickDeactivate = async () => {
        await updateUserProfile(user.id, { state: 'inactive' })
        setShowManageUserModal(false)
        setShowDeactivateModal(false)
        setShowSuccessDialog(true)
    }

    return (
        <>
            <DialogSuccess
                message="Account successfully deactivated"
                open={showSuccessDialog}
                onClose={() => setShowSuccessDialog(false)}
                buttonText="Back to Dashboard"
                title="Success"
                iconSrc="/assets/icons/icon-check-white-circle.svg"
                type="confirm"
            />

            <DialogDelete
                message="Are you sure you want to Deactive Account?"
                open={showDeactivateModal}
                onClose={() => setShowDeactivateModal(false)}
                buttonText="Deactive Account"
                onButtonClick={onClickDeactivate}
                title="Deactive Account?"
                iconSrc="/assets/icons/icon-check-white-circle.svg"
                type="confirm"
            />

            <DialogSales
                open={showSalesModal}
                user={user}
                onClose={() => setShowSalesModal(false)}
            />

            <Dialog open={open} onClose={onClose} className="relative z-[10000]">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-[#000] backdrop-blur-sm bg-opacity-75 transition-opacity"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden w-[550px] bg-[#141414] backdrop-blur-sm shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in  rounded-[15px]"
                        >
                            <div className="w-full flex flex-col relative p-6 min-h-[484px]">
                                <div className="flex justify-between">
                                    <div className="flex">
                                        <span className="text-primary text-[28px]">User Details</span>
                                    </div>

                                    <button
                                        onClick={onClose}
                                        className="top-2 right-2 cursor-pointer z-[1]"
                                    >
                                        <img
                                            src="/assets/icons/icon-close.svg"
                                            alt="Close"
                                            className="invert cursor-pointer"
                                        />
                                    </button>
                                </div>

                                <div className="mt-7">
                                    <div className="flex text-white items-center">
                                        <img src="/assets/avatars/default.png" className="rounded-[50%] w-[75px] mr-4" />

                                        <div>
                                            <div className="text-base">{user.displayName}</div>

                                            <div className="text-[#959595] text-sm mt-2 mr-1 flex items-center">
                                                <div className="mr-2">Plan tier:</div>

                                                <div className="px-2 py-1 bg-white text-primary rounded-[8px] uppercase">{user.membership} Plan</div>
                                            </div>
                                        </div>

                                        <div className="ml-auto mr-8">
                                            <div className="text-sm font-thin">
                                                Current Account Balance:
                                            </div>

                                            <div className="text-primary text-xl mt-2">
                                                ${user.balance.toFixed(2)}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex mt-6 text-white text-sm ml-2">
                                        <div>
                                            Email:

                                            <span className="text-[#767676] ml-1 font-thin">{user.email}</span>
                                        </div>
                                        <div className="ml-8">
                                            Phone:

                                            <span className="text-[#767676] ml-1 font-thin"> {user.phoneNumber}</span>
                                        </div>
                                    </div>

                                    <div className="ml-2 text-xs">
                                        <div className="mt-6 mb-2">
                                            <span className="text-primary">Withdraw History</span>
                                        </div>

                                        <div className="text-[#767676] font-light w-full">
                                            <div className="bg-white flex rounded-[6px] w-full relative h-[28px]">
                                                <div className="absolute left-1 font-thin py-1 pl-3 overflow-hidden text-start  top-[50%] -translate-y-1/2">
                                                    Withdraw method
                                                </div>
                                                <div className="absolute left-[40%] -ml-1 font-thin py-1 text-start  top-[50%] -translate-y-1/2">
                                                    Withdraw Date
                                                </div>
                                                <div className="absolute left-[70%] -ml-2 font-thin py-1 overflow-hidden text-start  top-[50%] -translate-y-1/2">
                                                    Withdraw Amount
                                                </div>
                                            </div>

                                            {
                                                withdrawals.length === 0 ?
                                                    <div className="max-h-[200px] overflow-auto text-center mt-4">
                                                        No withdrawals yet
                                                    </div> :
                                                    <div className="max-h-[200px] overflow-auto mt-1">
                                                        {
                                                            withdrawals.map((item, index) =>
                                                                <div key={`withdraw-${item.id}-${index}`} className="flex relative w-full h-[35px] rounded-[6px]">
                                                                    <div className="uppercase absolute left-1 top-[50%] -translate-y-1/2 py-3 pl-4">
                                                                        {item.method}
                                                                    </div>
                                                                    <div className="absolute  top-[50%] -translate-y-1/2 left-[40%]">
                                                                        {formatDate(item.created_at.seconds)}
                                                                    </div>
                                                                    <div className="absolute  top-[50%] -translate-y-1/2 left-[70%]">
                                                                        $ {item.amount.toFixed(2)}
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                            }

                                            <div className="flex mt-14 gap-3">
                                                <button className="text-white bg-primary py-3 text-xs rounded-[10px] w-full" onClick={() => setShowSalesModal(true)}>
                                                    View Sales
                                                </button>

                                                <button className="bg-[#E5E5E5] text-[#6E6E6E] py-3 text-xs rounded-[10px] w-full" onClick={() => setShowDeactivateModal(true)}>
                                                    Deactivate Account
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </>
    );
}
